import { PermissionsModel as Model } from './Model'


export const MODULE_NAME = 'permissions.permissions'

export const PERMISSIONS_PERMISSIONS_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: PERMISSIONS_PERMISSIONS_ROUTES.LAYOUT,
  route: { name: PERMISSIONS_PERMISSIONS_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-account-key-outline',
} as const
